import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Select from 'react-select';

import BotSettingApi from 'api/bot-setting';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import NotificationHelper from 'helpers/NotificationHelper';

const BotNotificationForm = ({ bot }) => {
  const { t } = useTranslation();

  const email_events = [
    { value: 'done', label: t('status.done') },
    { value: 'failed', label: t('status.failed') },
    { value: 'canceled', label: t('status.canceled') },
  ];

  const notifications = (bot.settings || []).find(setting => setting.id === 'notifications') || {};
  const notification_value = notifications.value || {};

  const [saving, setSaving] = useState(false);
  const [events, setEvents] = useState(email_events.filter(event => (notification_value.events || []).includes(event.value)));

  if (!bot) {
    return null;
  }

  const isEmailValid = email => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = async e => {
    e.preventDefault();

    const form_instance = new FormData(e.target);
    const form_entries = Object.fromEntries(form_instance);
    form_entries.events = events.map(e => e.value);

    for (const email of form_entries.emails.split(',')) {
      if (email.trim() && !isEmailValid(email.trim())) {
        alert(`Por favor, informe emails válidos. ${email} não é um email válido.`);
        return;
      }
    }

    try {
      setSaving(true);
      BotSettingApi.update(bot.id, 'notifications', { value: form_entries });
      NotificationHelper.successUpdate();
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="card" onSubmit={onSubmit}>
      <div className="card-body">
        <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('bots.config.notification.title')}</h6>
        <hr />

        <div className="form-group mt-3 mb-3">
          <label htmlFor="notificationEmailsInput">E-mails:</label>
          <textarea
            className="form-control"
            placeholder="joe@youfy.com.br, anne@youfy.com.br"
            id="notificationEmailsInput"
            defaultValue={notification_value.emails}
            name="emails"></textarea>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="notificationEmailsInput">{t('bots.config.notification.form.events')}</label>
          <Select
            value={events}
            isMulti
            name="events"
            onChange={setEvents}
            required
            options={email_events}
            className="basic-multi-select"
            classNamePrefix="select"
          />
        </div>

        <hr />
        <div className="form-group mb-4 mt-4">
          <SubmitButton loading={saving} className="btn btn-primary" />
        </div>
      </div>
    </form>
  );
};

export default withRouter(BotNotificationForm);
